// not too much here for now, simply grabs the list of "profile" states
import { createSelector } from 'reselect';

const _routeState = ({ globalRecruitmentProfiles }: any) => globalRecruitmentProfiles;

export const localRecruitmentProfilesSelector = createSelector(_routeState, ({ profiles }) => profiles || {});
